import { render, staticRenderFns } from "./PincelData.vue?vue&type=template&id=4af7829a&"
import script from "./PincelData.vue?vue&type=script&lang=js&"
export * from "./PincelData.vue?vue&type=script&lang=js&"
import style0 from "./PincelData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports